import React, { useEffect, useState } from 'react';
import { Check, Close } from '@mui/icons-material';

import {
  CloseButton,
  IconContainer,
  ToastContent,
  ToastCustomMessage,
  ToastItem,
  ToastTitle,
} from './styles';
import { ToastMessage } from './ToastContext';

interface ToastProps {
  toast: ToastMessage;
  onClose: (id: string) => void;
}

const ToastComponent: React.FC<ToastProps> = ({ toast, onClose }) => {
  const [isExiting, setIsExiting] = useState(false);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose(toast.id);
    }, 300);
  };

  useEffect(() => {
    if (toast.duration && toast.duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, toast.duration);

      return () => clearTimeout(timer);
    }
  }, [toast]);

  return (
    <ToastItem type={toast.type} isExiting={isExiting}>
      <IconContainer type={toast.type}>
        {toast.type === 'success' ? <Check fontSize="small" /> : <Close fontSize="small" />}
      </IconContainer>
      <ToastContent>
        <ToastTitle>{toast.message}</ToastTitle>
        {toast.customMessage && <ToastCustomMessage>{toast.customMessage}</ToastCustomMessage>}
      </ToastContent>
      <CloseButton onClick={handleClose}>
        <Close fontSize="medium" />
      </CloseButton>
    </ToastItem>
  );
};

export default ToastComponent;
